module.exports = __webpack_public_path__ + "img/icone-menu.93a680a3.svg";